// Standalone IRoutes enum, extracted from routes.tsx so importing just
// the route constants does NOT pull the whole routing graph (lazy route
// table + layouts -> app store). routes.tsx re-exports this for the app;
// the marketing site imports it directly to stay off the app bundle.

export enum IRoutes {
    main = "/",
    menuHub = "/menu-hub",
    twoFactorAuthentication = "/2FA",
    loginPage = "/login",
    recoverPassword = "/recoverpassword",
    changePassword = "/changepassword",
    signUp = "/signup",
    attribute = "/admin/attribute",
    bugs = "/admin/bugs",
	resourceCatalog = "/admin/resourcecatalog",
    attributeForm = "/admin/attribute/form/popup",
    attributeFormEdit = "/admin/attribute/form/popup/edit",
    entity = "/admin/entity",
    entityForm = "/admin/entity/form/popup",
    entityFormEdit = "/admin/entity/form/popup/edit",
    group = "/admin/group",
    groupForm = "/admin/group/form/popup",
    groupFormEdit = "/admin/group/form/popup/edit",
    planner = "/admin/planner",
    view = "/admin/view",
    office = "/admin/office",
	officeResource = "/admin/office/resources",
	officeResourceTasks = "/tasks/resources",
	officeResourceAllocation = "/admin/office/resource-allocations",
    officeForm = "/admin/office/form/popup",
    officeFormEdit = "/admin/office/form/popup/edit",
    dashboard = "/admin/dashboard",
    configuration = "/admin/configuration",
    // One Configuração section (slug from components/configuration/settings/settingsPaths).
    configurationSection = "/admin/configuration/:section",
    revolutCallback = "/revolut/callback",
    bankCallback = "/bank/callback",
    socialOAuthCallback = "/social/:platform/callback",
    copilotOAuthCallback = "/microsoft/copilot/callback",
    personalWorkspaceCallback = "/workspace/:provider/callback",
    // OAuth2 billing providers (/billing/fattureincloud/callback, /billing/xero/callback).
    billingOAuthCallback = "/billing/:provider/callback",
	commerceRequests = "/admin/commerce/requests",
	commerceMarketplace = "/admin/commerce/marketplace",
	commerceShop = "/admin/commerce/shop",
	// "Como ordenamos os resultados": how the Shop ranks listings (sponsored slots included).
	commerceShopRanking = "/admin/commerce/shop/ranking",
	commerceContracts = "/admin/commerce/contracts",
	// Per-kind marketplace contract templates (Admin+).
	commerceContractTemplates = "/admin/commerce/contract-templates",
	commerceSchedules = "/admin/commerce/schedules",
	commerceFinance = "/admin/commerce/finance",
	commerceOrders = "/admin/commerce/orders",
	commerceMyOrders = "/commerce/my-orders",
	commerceBookings = "/admin/commerce/bookings",
	clientPortal = "/fidava/portal",
	clientBookings = "/fidava/bookings",
	// Client-role customer B2B surfaces. Same components as the /admin/commerce
	// equivalents, but under /fidava so the Client guard permits them and they
	// render on AuthorizedFormLayout (no admin chrome).
	clientMarketplace = "/fidava/marketplace",
	clientShop = "/fidava/shop",
	clientShopRanking = "/fidava/shop/ranking",
	clientOrders = "/fidava/orders",
	// Partner (reseller) program. Portal = the restricted partner self-service
	// area (its own /partner/ prefix so the AuthorizedLayout guard can keep a
	// Partner-role login confined to it). partnersAdmin = default-tenant
	// management (Security hub card). becomePartner = public application form.
	partnerPortal = "/partner/portal",
	partnersAdmin = "/admin/partners",
	becomePartner = "/partner/apply",
	// Public onboarding magic-links (emailed after approval / activation).
	partnerAgreement = "/partner/agreement/:token",
	contractSign = "/contract/sign/:token",
	productReviewSubmit = "/rate/:token",
	partnerSetup = "/partner/setup/:token",
    notification = "/admin/notification",
    notificationForm = "/admin/notification/form/popup",
    notificationFormEdit = "/admin/notification/form/popup/edit",
    contentManager = "/admin/contentmanager",
    emailDraftQueue = "/admin/email/queue",
    events = "/tasks/events",
    eventForm = "/tasks/events/form/popup",
    eventFormEdit = "/tasks/events/form/popup/edit",
    eventFormView = "/tasks/events/form/popup/view",
    eventMap = "/tasks/map",
    calendar = "/tasks/calendar",
	gantt = "/tasks/gantt",
    kabanBoard = "/tasks/kanban",
    eventGamification = "/tasks/gamification",
    eventDashboard = "/tasks/dashboard",
    actionPlans = "/tasks/action-plans",
    user = "/admin/user",
    userForm = "/admin/user/form/popup",
    userFormEdit = "/admin/user/form/popup/edit",
    data = "/tasks/data",
    dataSummary = "/admin/data/summary",
    dataPrimer = "/admin/data/learn",
    dataBuilder = "/admin/data/build",
    orgDesigner = "/admin/org-designer",
    businessStarter = "/admin/business-starter",
    agentWorkers = "/admin/agent-workers",
    hrSummary = "/admin/hr/summary",
    communicationSummary = "/admin/communication/summary",
    communicationLog = "/admin/communication/log",
    googleDashboard = "/admin/communication/google-dashboard",
    productPush = "/admin/communication/product-push",
    productReviews = "/admin/communication/product-reviews",
    dataForm = "/tasks/data/form/popup",
    dataFormEdit = "/tasks/data/form/popup/edit",
    dataViewForm = "/tasks/data/form/popup/view",
    dataIntegration = "/admin/data/integration",
    translations = "/admin/data/translations",
    process = "/admin/process",
    processDiagram = "/admin/process/form/popup/edit",
    role = "/admin/role",
    roleForm = "/admin/role/form/popup",
    roleFormEdit = "/admin/role/form/popup/edit",
    kiosk = "/tasks/kiosk",
    kioskForm = "/tasks/kiosk/form/popup",
    kioskFormEdit = "/tasks/kiosk/form/popup/edit",
    kioskView = "/tasks/kiosk/view/:viewId",
    kioskSearchUpdate = "/kiosk/search",
    userLocation = "/geoLocation",
    eventInHouseLocation = "/tasks/in-house-location",
    powerBi = "/analyzes",
    chat = "/chat",
    // Standalone chat app — its own webpack entry (boot-chat.tsx), so links to
    // it must be full navigations (href / location), not history.push.
    messenger = "/messenger",
    license = "/license",
    wizard = "/startupWizard",
    webHome = "/fidava",
    brochure = "/fidava/brochure",
    script = "/admin/script",
    scriptForm = "/admin/script/form/popup",
    scriptFormEdit = "/admin/script/form/popup/edit",
    systemLog = "/admin/systemlog",
    systemLogForm = "/admin/systemlog/form/popup",
    workerControl = "/admin/system/workers",
    qrcodecam = "/events/search",
    testing = "/testing",
    emailGoogleIntegration = "/google/gmail",
    emailGoogleCalendarIntegration = "/google/calendar",
    emailGoogleIntegrationMessage = "/google/gmail/message",
    driveGoogleIntegration = "/google/drive",
    meetAttendanceDashboard = "/admin/meet-attendance",
    unauthorized = "/unauthorized",
    people = "/contact/people",
    peopleForm = "/contact/people/form/popup/",
    peopleFormEdit = "/contact/people/form/popup/edit"
	, billing = "/admin/billing"
	, invoicing = "/admin/invoicing"
	, invoicingDashboard = "/admin/invoicing/dashboard"
	, invoicingDocuments = "/admin/invoicing/documents"
	, invoicingClients = "/admin/invoicing/clients"
	, invoicingProducts = "/admin/invoicing/products"
	, invoicingWarehouses = "/admin/invoicing/warehouses"
	, invoicingCategories = "/admin/invoicing/categories"
	, invoicingCollaborators = "/admin/invoicing/collaborators"
	, invoicingVehicles = "/admin/invoicing/vehicles"
	, invoicingOperations = "/admin/invoicing/operations"
	, invoicingMasterData = "/admin/invoicing/master-data"
	, insurancePolicies = "/admin/insurance-policies"
	, purchases = "/admin/purchases"
	, purchasesSuppliers = "/admin/purchases/suppliers"
	, purchasesWarehouses = "/admin/purchases/warehouses"
	, purchasesWarehouseLocations = "/admin/purchases/warehouse-locations"
	, purchasesDocuments = "/admin/purchases/documents"
	, purchasesParts = "/admin/purchases/parts"
	, purchasesPurchaseOrders = "/admin/purchases/purchase-orders"
	, purchasesMovements = "/admin/purchases/movements"
	, purchasesSupplierBills = "/admin/purchases/supplier-bills"
	, purchasesDashboard = "/admin/purchases/dashboard"
	, purchasesConsumption = "/admin/purchases/consumption"
	, purchasesStockView = "/admin/purchases/stock-view"
	, purchasesSupplierQualification = "/admin/purchases/supplier-qualification"
	, purchasesSupplierAudits = "/admin/purchases/supplier-audits"
	, sales = "/admin/sales"
	, salesLeads = "/admin/sales/leads"
	, salesOpportunities = "/admin/sales/opportunities"
	, salesActivities = "/admin/sales/activities"
	, salesDashboard = "/admin/sales/dashboard"
	, salesLeadSources = "/admin/sales/lead-sources"
	, salesLeadChats = "/admin/sales/lead-chats"
	// Fidava support inbox for tenant support chats (default tenant, SuperAdmin/Support).
	, supportChats = "/admin/support/chats"
	, salesProspectLists = "/admin/sales/prospect-lists"
	, salesCampaigns = "/admin/sales/campaigns"
	, salesMarketing = "/admin/sales/marketing"
	, salesMarketingPlans = "/admin/sales/marketing-plans"
	, salesMarketingCalendar = "/admin/sales/marketing-calendar"
	, salesMarketingAssets = "/admin/sales/marketing-assets"
	, clientCredentials = "/admin/client-credentials"
	, integrationHealth = "/admin/configuration/integration-health"
	, integrationSetupGuide = "/admin/configuration/integration-setup-guide"
	, integrationSetupGuidePage = "/admin/configuration/integration-setup-guide/:guide"
	, whiteboard = "/tasks/whiteboard"
	, attendance = "/attendance"
	, attendanceAdmin = "/admin/attendance"
	, attendanceMatrix = "/admin/attendance/matrix"
	, collaborators = "/admin/hr/collaborators"
	, benefitTypes = "/admin/hr/benefit-types"
	, ptIrsBrackets = "/admin/hr/pt-irs-brackets"
	, payslips = "/admin/hr/payslips"
	, holidayOverview = "/admin/hr/holiday-overview"
	, skillCatalog = "/admin/hr/skills"
	, performanceReviews = "/admin/hr/performance-reviews"
	, candidates = "/admin/hr/candidates"
	// Recruitment job postings (backoffice) + PUBLIC per-tenant careers board.
	, hrJobs = "/admin/hr/jobs"
	, hrJobPipeline = "/admin/hr/jobs/:id/pipeline"
	, careers = "/careers/:slug"
	, careersJob = "/careers/:slug/jobs/:id"
	// Sign-in-with-LinkedIn OAuth landing for the public apply flow. Declared
	// as a literal path — it wins over /careers/:slug by segment count.
	, careersLinkedInCallback = "/careers/linkedin/callback"
	// Public MCQ assessment magic-link — the emailed single-use token is the auth.
	, assessment = "/assessment/:token"
	// Fidava Sports secret-vote link — the single-use token is the auth.
	, publicVote = "/vote/:token"
	// Fidava Sports member portal — ask for a link; the personal link is the auth.
	, memberPortal = "/portal"
	, memberPortalLink = "/portal/:token"
	// Fidava Sports tournament public page — anonymous; the organizer made it public.
	, publicTournament = "/t/:slug"
	, publicCallUp = "/callup/:token"
	, publicPlayerProfile = "/scout/:token"
	, finance = "/admin/finance"
	, financeOverview = "/admin/finance/overview"
	, financeProjection = "/admin/finance/projection"
	, financeTaxes = "/admin/finance/taxes"
	, lenders = "/admin/finance/lenders"
	, liabilities = "/admin/finance/liabilities"
	, monthlyLiabilityExpenses = "/admin/finance/monthly-expenses"
	, expenses = "/admin/finance/expenses"
	, financeCategories = "/admin/finance/categories"
	, financeClassifications = "/admin/finance/classifications"
	, payments = "/admin/finance/payments"
	, revolutReconciliation = "/admin/commerce/revolut-reconciliation"
	, revolutAccounts = "/admin/commerce/revolut-accounts"
	, equipment = "/admin/equipment"
	, equipmentList = "/admin/equipment/assets"
	, equipmentLive = "/admin/equipment/live"
	, equipmentAlertRules = "/admin/equipment/alert-rules"
	, equipmentAlerts = "/admin/equipment/alerts"
	, equipmentGateways = "/admin/equipment/gateways"
	, equipmentInstructions = "/admin/equipment/instructions"
	, equipmentRobotFleets = "/admin/equipment/robot-fleets"
	// Outside /admin: the QR target operators open on the floor (any operational role).
	, equipmentInstructionRun = "/equipment/:equipmentId/instructions"
	// Outside /admin: warehouse workers (any operational role) run the board.
	, transportTasks = "/equipment/transport-tasks"
	, supplierPoResponse = "/supplier/po/:token"
	, accessAlert = "/security/access/:token"
	, accountSecurity = "/account/security"
	, connectAi = "/connect/ai"
	, ipAccessControl = "/admin/security/ip-access"
	, securityPosture = "/admin/security/posture"
	, approvals = "/admin/approvals"
	, expenseClaims = "/admin/hr/expense-claims"
	, financeExpenseClaims = "/admin/finance/expense-claims"
	, approvalPolicy = "/admin/approvals/policy"
	, webhooks = "/admin/configuration/webhooks"
	, automationRules = "/admin/configuration/automation-rules"
	, eventSla = "/admin/configuration/sla"
	, brandKit = "/admin/configuration/brand-kit"
	// ── Section hubs ─────────────────────────────────────────────────
	// Each hub is a landing-page-with-cards (mirrors the Sales / Purchases
	// hubs). The sidebar shows one top-level icon per hub; the cards
	// dispatch to the existing leaf routes above.
	, dataHub = "/admin/hub/data"
	, workspaceHub = "/admin/hub/workspace"
	, communicationHub = "/admin/hub/communication"
	, eventHub = "/admin/hub/event"
	, securityHub = "/admin/hub/security"
	, systemHub = "/admin/hub/system"
	, analyticsHub = "/admin/hub/analytics"
	, commerceHub = "/admin/hub/commerce"
	, hrHub = "/admin/hub/hr"
	, configurationHub = "/admin/hub/configuration"
	, facilitiesHub = "/admin/hub/facilities"
	, qualityHub = "/admin/hub/quality"
	, audits = "/admin/audits"
	, supplierComplaints = "/admin/supplier-complaints"
	, qualityDashboard = "/admin/quality-dashboard"
	// Social Media app (LinkedIn + Instagram). Hub + its leaf pages.
	, socialHub = "/admin/social"
	, socialPosts = "/admin/social/posts"
	, socialCalendar = "/admin/social/calendar"
	, socialDashboard = "/admin/social/dashboard"
	, socialComments = "/admin/social/comments"
	// Economy add-on (IMF macroeconomic data) — an Analytics hub card.
	, economy = "/admin/economy"
	// Fidava Sports (association module). Hub + its leaf pages.
	, associationHub = "/admin/association"
	, associationSettings = "/admin/association/settings"
	, associationQuickStart = "/admin/association/quick-start"
	// Business tenants' guided setup (SuperAdmin). Sports clubs have their own above.
	, businessQuickStart = "/admin/quick-start"
	, associationMembers = "/admin/association/members"
	, associationGovernance = "/admin/association/governance"
	, associationDues = "/admin/association/dues"
	, associationAssemblies = "/admin/association/assemblies"
	, associationAssembly = "/admin/association/assemblies/:id"
	, associationTeams = "/admin/association/teams"
	, associationEvents = "/admin/association/events"
	, associationAvailability = "/admin/association/availability"
	, associationEvaluations = "/admin/association/evaluations"
	, associationTeamAnalysis = "/admin/association/team-analysis"
	, associationReports = "/admin/association/reports"
	, associationTactics = "/admin/association/tactics"
	, associationModalities = "/admin/association/modalities"
	, associationTournaments = "/admin/association/tournaments"
	, facilitiesFloorPlans = "/admin/facilities/floor-plans"
	, floorPlanner = "/admin/facilities/floor-planner"
	, facilitiesInventory = "/admin/facilities/inventory"
	, facilitiesWorkAreas = "/admin/facilities/work-areas"
	, facilitiesFieldReports = "/admin/facilities/field-reports"
}
